// extracted by mini-css-extract-plugin
export default {"aiGenerated":"AIGeneratedBadge_aiGenerated__QJIiY","aiGeneratedText":"AIGeneratedBadge_aiGeneratedText__OJACC"};